import fetchApi from "../fetchApi";
export const CreateOrder = async (firstName, lastName, shippingId, programId, quantity, code, office) => {

    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            "first_name": firstName,
            "last_name": lastName,
            "shipping_address_id": shippingId,
            "program_id": programId,
            "quantity": quantity,
            "package_code": code,
            "office_id": office
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/order`, options);
};